import React from 'react';
import { Box, Avatar, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../../redux/slices/authSlice';
import { Message as MessageType } from '../hooks/useChat';
import LogoIcon from '../../../components/LogoIcon';
import MarkdownRenderer from './MarkdownRenderer';

interface MessageProps {
    message: MessageType;
}

const Message: React.FC<MessageProps> = ({ message }) => {
    const user = useSelector(selectCurrentUser);
    const isUser = message.from === 'user';

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'flex-end',
            mb: 1.5,
            maxWidth: '75%',
            alignSelf: isUser ? 'flex-end' : 'flex-start',
            flexDirection: isUser ? 'row-reverse' : 'row',
        }}>
            <Avatar sx={{
                width: 40,
                height: 40,
                mx: 1,
                bgcolor: isUser ? 'primary.main' : 'custom.greenBot',
                color: isUser ? 'primary.contrastText' : 'secondary.contrastText',
            }}>
                {isUser ? (
                    <img src={user?.picture} alt="avatar" style={{ width: '100%', height: '100%' }} />
                ) : (
                    <LogoIcon width={20} height={20} />
                )}
            </Avatar>
            <Box>
                <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', textAlign: isUser ? 'right' : 'left' }}>
                    {isUser ? (user?.name || 'Tú') : message.sender}
                </Typography>
                <Box sx={{
                    px: 2,
                    py: 1,
                    borderRadius: '20px',
                    bgcolor: isUser ? 'primary.main' : 'background.paper',
                    color: isUser ? 'primary.contrastText' : 'text.primary',
                    borderBottomRightRadius: isUser ? '5px' : '20px',
                    borderBottomLeftRadius: isUser ? '20px' : '5px',
                    boxShadow: 1,
                }}>
                    <Typography variant="body1"><MarkdownRenderer content={message.text} /></Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default Message;
